/*
 * Javascript Diff Algorithm
 *  By John Resig (http://ejohn.org/)
 *  Modified by Chu Alan "sprite"
 *
 * Released under the MIT license.
 *
 * More Info:
 *  http://ejohn.org/projects/javascript-diff-algorithm/
 *
 * diffString( String oldStr, String newStr )
 *  This method takes two strings and calculates the differences in each.
 *  The final result is the ‘newStr’ marked up with HTML (to signify both
 *  deletions from the oldStr and additions to the newStr).
 *
 * Sample Code:
 * const diff = diffString(
 *  "The red brown fox jumped over the rolling log.",
 *  "The brown spotted fox leaped over the rolling log"
 * );
 *
 * Sample Output:
 * The <del>red</del>brown <ins>spotted</ins> fox <del>jumped</del><ins>leaped</ins> over the rolling log.
 *
 * TODO: Fix type errors by removing evil javascript magic.
 */

function escape(s: string) {
    let n = s;
    n = n.replace(/&/g, "&amp;");
    n = n.replace(/</g, "&lt;");
    n = n.replace(/>/g, "&gt;");
    n = n.replace(/"/g, "&quot;");

    return n;
}

export function diffString(o: string, n: string): string {
    o = o.replace(/\s+$/, "");
    n = n.replace(/\s+$/, "");

    const out = diff(o === "" ? [] : o.split(/\s+/), n === "" ? [] : n.split(/\s+/));
    let str = "";

    let oSpace = o.match(/\s+/g);
    if (oSpace == null) {
        oSpace = [""];
    } else {
        oSpace.push("");
    }
    let nSpace = n.match(/\s+/g);
    if (nSpace == null) {
        nSpace = [""];
    } else {
        nSpace.push("");
    }

    if (out.n.length === 0) {
        for (var i = 0; i < out.o.length; i++) {
            str += "<del>" + escape(out.o[i]) + oSpace[i] + "</del>";
        }
    } else {
        if (out.n[0].text == null) {
            for (var i = 0; i < out.o.length && out.o[i].text == null; i++) {
                str += "<del>" + escape(out.o[i]) + oSpace[i] + "</del>";
            }
        }

        for (var i = 0; i < out.n.length; i++) {
            if (out.n[i].text == null) {
                str += "<ins>" + escape(out.n[i]) + nSpace[i] + "</ins>";
            } else {
                let pre = "";

                for (let j = out.n[i].row + 1; j < out.o.length && out.o[j].text == null; j++) {
                    pre += "<del>" + escape(out.o[j]) + oSpace[j] + "</del>";
                }
                str += out.n[i].text + nSpace[i] + pre;
            }
        }
    }

    return str.trim();
}

function diff(oo: string[], nn: string[]): { o: any[]; n: any[] } {
    const ns: Record<string, { rows: number[]; o: string | null }> = {};
    const os: Record<string, { rows: number[]; n: string | null }> = {};
    const o: any[] = oo;
    const n: any[] = nn;

    for (var i = 0; i < n.length; i++) {
        if (ns[n[i]] == null) ns[n[i]] = { rows: [], o: null };
        ns[n[i]].rows.push(i);
    }

    for (var i = 0; i < o.length; i++) {
        if (os[o[i]] == null) os[o[i]] = { rows: [], n: null };
        os[o[i]].rows.push(i);
    }

    for (const k in ns) {
        if (ns[k].rows.length === 1 && typeof os[k] !== "undefined" && os[k].rows.length === 1) {
            n[ns[k].rows[0]] = { text: n[ns[k].rows[0]], row: os[k].rows[0] };
            o[os[k].rows[0]] = { text: o[os[k].rows[0]], row: ns[k].rows[0] };
        }
    }

    for (var i = 0; i < n.length - 1; i++) {
        if (
            n[i].text != null &&
            n[i + 1].text == null &&
            n[i].row + 1 < o.length &&
            o[n[i].row + 1].text == null &&
            n[i + 1] === o[n[i].row + 1]
        ) {
            n[i + 1] = { text: n[i + 1], row: n[i].row + 1 };
            o[n[i].row + 1] = { text: o[n[i].row + 1], row: i + 1 };
        }
    }

    for (var i = n.length - 1; i > 0; i--) {
        if (
            n[i].text != null &&
            n[i - 1].text == null &&
            n[i].row > 0 &&
            o[n[i].row - 1].text == null &&
            n[i - 1] === o[n[i].row - 1]
        ) {
            n[i - 1] = { text: n[i - 1], row: n[i].row - 1 };
            o[n[i].row - 1] = { text: o[n[i].row - 1], row: i - 1 };
        }
    }

    return { o: o, n: n };
}
